<template>
    <div class="online_word no-trans" v-loading="loading">
        <div class="online_word_box">            
            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > 法律咨询 >在线咨询
            </div>
            <div class="chat_box">
                <div class="chat">
                    <div class="cat_title_flex">
                        <div class="titles">
                           <img src="../../assets/img/index/legal/icons2.png" alt=""> 
                            在线咨询
                        </div>
                        <div class="btns_flex">
                            <!--                      -->
                            <div class="btns1">01提交问题</div>
                            <div class="gt_img">
                                <img src="../../assets/img/index/legal/icons3.png" alt=""> 
                            </div>
                            <div class="btns2">02律师回复</div>
                            <div class="gt_img">
                                <img src="../../assets/img/index/legal/icons4.png" alt=""> 
                            </div>
                            <div class="btns2">03查看问题</div>
                        </div>
                    </div>
                    <div class="textarea_box">
                        <textarea name="" id="" maxlength="500" placeholder="现非工作时间，可先留下你的疑问。" v-model="texts" ></textarea>
                    </div>
                    <div class="img_list">
                        <div class="imgs" v-for="(item,index) in 2" :key="index">
                            <img src="../../assets/img/index/legal/icons4.png" alt=""> 
                        </div>
                        <div class="imgs_add" >
                            <div class="img_add_img">
                                <img src="../../assets/img/index/legal/add_img.png" alt=""> 
                            </div>
                            <div class="add_text">添加图片</div>
                        </div>
                    </div>
                    <div class="chat_nums">
                        <div class="nums_text">请描述您的问题（0-500字）</div>
                    </div>
                    <div class="btns_flex">
                        <div class="nums_text">{{ texts.length }}/500</div>
                        <div class="btns" @click="handle_end">提交</div>
                    </div>
                </div>
                <div class="chat_flex">
                    <div class="btns1">法律裁判点评网</div>
                    <div class="btns1">已有 <span>26,322</span> 人提出问题</div>
                    <div class="btns1">律师已解答：<span>63,173</span> 问题</div>
                </div>
            </div>
        </div>
        <online_success ref="online_success"></online_success>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import online_success from '@/components/legal_advice/online_success.vue'//提交成功



export default {
    components: {
        online_success
    },
    name: "homes",
    data() {
        return {
            loading: false,
            texts:'',
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        },
        change_banner(e){
            // console.log('却换触发',e)
            this.banner_ac=e
        },
        handle_end(){
            this.$refs.online_success.handle_open()
        },

    },

}
</script>
<style scoped lang="less">
.online_word {
    width: 100%;
    // height: 900px;
    padding-bottom: 200px;
    background-color: #F5F5F5;
    .online_word_box{
        width: 1440px;
        height: 100%;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .chat_box{
            width: 960px;
            height: 560px;
            // background: #FFFFFF;
            // box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
            // border-radius: 20px 20px 20px 20px;
            margin: auto;
            .chat{
                width: 960px;
                height: 560px;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                border-radius: 20px 20px 20px 20px;
                .cat_title_flex{
                    display: flex;
                    align-content: center;
                    justify-content: space-between;
                    border-bottom: 1px solid #E8E8E8;
                    height: 50px;
                    padding: 0 32px;

                    .titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        // line-height: 50px;
                        display: flex;
                        align-items: center;
                        img{
                            width: 17px;
                            height: 17px;
                            margin-right: 8px;
                        }
                    }
                    .btns_flex{
                        display: flex;
                        align-items: center;
                        .btns1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #377CFD;
                            cursor: pointer;

                        }
                        .btns2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;
                            cursor: pointer;
                        }
                        .gt_img{
                            padding: 0 20px;
                            display: flex;
                            align-items: center;

                            img{
                                width: 4px;
                                height: 6px;
                            }
                        }
                    }
                }
                .textarea_box{
                    padding:15px 32px;
                    height: 300px;
                    textarea{
                        width: 100%;
                        height: 100%;
                    }
                }
                .img_list{
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    padding: 0 32px;
                    .imgs{
                        width: 70px;
                        height: 70px;
                        background: rgba(206,206,206,0.04);
                        border: 1px solid rgba(0,0,0,0.15);
                        margin-right: 10px;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .imgs_add{
                        width: 70px;
                        height: 70px;
                        background: rgba(206,206,206,0.04);
                        border: 1px dashed  rgba(0,0,0,0.15);
                        cursor: pointer;
                        padding-top: 16px;
                        .img_add_img{
                            width: 22px;
                            height: 22px;
                            border: 1px dashed  rgba(0,0,0,0.15);
                            margin: auto;
                            display: flex;
                            align-items: center;
                            img{
                                width: 22px;
                                height: 22px;
                            }
                        }
                        .add_text{
                            padding-top: 5px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 9px;
                            color: #878787;
                            text-align: center;
                        }
                    }
                }
                .chat_nums{
                    width: 960px;
                    height: 36px;
                    background: #F5F5F5;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 16px;
                    padding: 0 32px;
                    .nums_text{
                        line-height: 36px; 
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9C9EA0;

                    }
                }
                .btns_flex{
                    display: flex;
                    align-items: end;
                    justify-content: end;
                    // align-content: end;
                    padding: 0 32px;
                    padding-top: 28px;
                    .nums_text{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        margin-right: 24px;
                    }
                    .btns{
                        width: 80px;
                        height: 36px;
                        background: #377CFD;
                        border-radius: 6px 6px 6px 6px;
                        text-align: center;
                        line-height: 36px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        cursor: pointer;
                    }
                }
            }
            .chat_flex{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 40px;
                padding-top: 32px;
                .btns1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #666666;
                    span{
                        color: #377CFD;
                    }
                }

            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .online_word.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .online_word.no-trans .online_word_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .online_word.no-trans .online_word_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding: 16px 0;
    }
    .online_word.no-trans .online_word_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .online_word.no-trans .online_word_box .chat_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin: auto;
    }
    .online_word.no-trans .online_word_box .chat_box .chat {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .cat_title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        height: auto;
        padding: 0 16px;
        min-height: 44px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .cat_title_flex .titles {
        font-size: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .cat_title_flex .titles img {
        width: 17px;
        height: 17px;
        margin-right: 8px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .cat_title_flex .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .cat_title_flex .btns_flex .btns1 {
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .cat_title_flex .btns_flex .btns2 {
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .cat_title_flex .btns_flex .gt_img {
        padding: 0 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .cat_title_flex .btns_flex .gt_img img {
        width: 4px;
        height: 6px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .textarea_box {
        padding: 15px 16px;
        min-height: 0;
        height: auto;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .img_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .img_list .imgs {
        width: 70px;
        height: 70px;
        margin-right: 10px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .img_list .imgs_add {
        width: 70px;
        height: 70px;
        padding-top: 16px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .img_list .imgs_add .img_add_img {
        width: 22px;
        height: auto;
        margin: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 22px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .img_list .imgs_add .img_add_img img {
        width: 22px;
        height: 22px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .img_list .imgs_add .add_text {
        padding-top: 5px;
        font-size: 14px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .chat_nums {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 36px;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 0 16px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .chat_nums .nums_text {
        line-height: 36px;
        font-size: 14px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        padding-top: 16px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .btns_flex .nums_text {
        font-size: 14px;
        margin-right: 16px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat .btns_flex .btns {
        width: 80px;
        height: auto;
        border-radius: 6px 6px 6px 6px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        padding-top: 16px;
    }
    .online_word.no-trans .online_word_box .chat_box .chat_flex .btns1 {
        font-size: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
